const fileUploads =  document.querySelectorAll('.ginput_container_fileupload input[type=file]');

// add change event listener to all file upload inputs.
fileUploads.forEach((fileUpload) => {
    fileUpload.addEventListener('change', handleFiles, false);
});

/**
 * Callback function for onchange event on input[type=file]
 */
function handleFiles() {
    const fileList = this.files;
    const fileName = fileList[0].name;

    // if it's already created, first remove and then create.
    if (isElementExist('.file-name')) {
        isElementExist('.file-name').remove();
    }

    // Create a div to insert after input[type=file].
    const fileDiv = document.createElement('div');
    fileDiv.classList.add('file-name');
    fileDiv.innerText = fileName;
    insertAfter(fileDiv, this);

    // Calculate space left od the file upload input
    const calcWidth = this.parentNode.parentNode.offsetWidth - this.offsetWidth - 10;
    isElementExist('.file-name').style.width = `${calcWidth}px`;
}

/**
 * // Insert element after target element
 *
 * @param {Node} newNode
 * @param {Node} referenceNode
 */
function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

/**
 * // if element is exist, return it.
 *
 * @param {string} className
 * @returns {HTMLElement}
 */
const isElementExist = (className) => document.querySelector(className);
